import { IconButton, type IconButtonProps } from '@mui/material';
import type { FC, ReactElement } from 'react';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

export const ExpandMore: FC<ExpandMoreProps> = ({ expand, ...other }): ReactElement => {
  return <IconButton style={{ transform: expand ? 'rotate(180deg)' : undefined }} {...other} />;
};
